import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const UpdateApplication = MatxLoadable({
  loader: () => import("./UpdateApplication")
})

const UpdateApplicationRoutes = [
  {
    path: "/update_application",
    component: UpdateApplication,
    auth: authRoles.admin
  }
];

export default UpdateApplicationRoutes;